import React from 'react';

import * as types from './../../actions/actionTypes';
import PatternCardBase from './PatternCardBase';

const PatternCard = ({ pattern, thumbnailType, children, overlay, overlayPath, sewpatId }) => {
    const imgUri = pattern.thumbnails[thumbnailType].url;

    const LinkProps = {
        type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
        payload: {
            patternid: pattern.id,
            sewpatId,
        },
    };

    const title = `${pattern.id}: ${pattern.title}`;

    return (
        <PatternCardBase imgUri={imgUri} title={title} LinkProps={LinkProps} overlay={overlay} overlayPath={overlayPath}>
            {children}
        </PatternCardBase>
    );
};

export default PatternCard;



// WEBPACK FOOTER //
// ./src/components/patterngalleries/PatternCard.js